import { render, staticRenderFns } from "./BsImageSel.vue?vue&type=template&id=53600e18"
import script from "./BsImageSel.vue?vue&type=script&lang=js"
export * from "./BsImageSel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports